import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { WafError } from '../constant/type';

export type WafErrorState = {
  displayModal: boolean;
  correlationId: string;
  url: string;
  method: string;
};

const initialState: WafErrorState = {
  displayModal: false,
  correlationId: '',
  url: '',
  method: '',
};

export const wafErrorReducer = createSlice({
  name: 'wafError',
  initialState,
  reducers: {
    populateWafError(state, action: PayloadAction<WafError>) {
      state.displayModal = true;
      state.correlationId = action.payload.correlationId;
      state.method = action.payload.method;
      state.url = action.payload.url;
    },
    resetState: () => initialState,
  },
});

export const { populateWafError, resetState } = wafErrorReducer.actions;

export default wafErrorReducer.reducer;
